import { createStyles } from '@material-ui/core/styles';

export default () => createStyles({
  root: {
    padding: 16,
    borderRadius: 10,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  title: {
    fontWeight: 600,
    fontSize: 18,
  },
  badge: {
    background: '#DB5C0E',
    width: 25,
    height: 25,
    borderRadius: '50%',
    fontSize: 12,
    fontWeight: 600,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  table: {
    tableLayout: 'fixed',
    width: '100%',
  },
  tableBody: {
    flex: 1,
    overflowY: 'auto',
    overflow: 'hidden',
  },
  tableHead: {
    '& th': {
      fontSize: 14,
      color: '#999',
      fontWeight: 600,
      textTransform: 'uppercase',
      borderBottom: '1px solid #f0f0f0',
      padding: '8px 12px',
    },
  },
  tableRow: {
    '&:last-child td': { border: 0 },
    '& td': {
      padding: '10px 12px',
      fontSize: 13,
      borderBottom: '1px solid #f9f9f9',
    },
  },
  hubSerial: {
    color: '#DB5C0E',
    fontWeight: 600,
  },
  avatar: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: '50%',
    fontSize: 11,
    fontWeight: 600,
    marginRight: 6,
    background: '#f0ede8',
    color: '#DB5C0E',
  },
  activatedByCell: {
    display: 'flex',
    alignItems: 'center',
  },
  eventBadge: {
    display: 'inline-block',
    padding: '3px 10px',
    borderRadius: 50,
    fontSize: 12,
    fontWeight: 500,
  },
  sortableCell: {
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
  sortCell: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  sortIcon: {
    fontSize: 16,
    width: 16,
    height: 16,
  },
});
